import { useEffect } from "react";

const useVisibilityFocus = (
  getEl: () => Element | null | undefined,
  onVisible: () => void,
) => {
  useEffect(() => {
    const el = getEl();
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) onVisible();
    });

    observer.observe(el);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useVisibilityFocus;
